export default function getUrlParameter(name) {
  if (typeof name !== "string" || name === "") {
    return null;
  }

  // modified polyfill for URLSearchParams from https://davidwalsh.name/query-string-javascript
  if (typeof window.URLSearchParams !== "function") {
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(window.location.search);
    return results === null
      ? null
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(name);
}
